import React from "react";
import PropTypes from "prop-types";

import { ChevronLeft } from "react-feather";
import { Button } from "@narmi/design_system";
import Feature from "byzantine/src/Feature";
import { useIsSidebarEnabled } from "../src/modules/sidebar/sidebar.hooks";

/**
  Base banner for redesigned pages. From left to right, the components are:
  1. optional chevron back button
  2. title
  3. optional icon
  4. optional button performing a passed-in function
*/
export default function BaseBanner({
  goBack = undefined,
  bannerName,
  features = {},
  buttonName = "",
  orFeatureFlagChecks = /** @type {string[]} */ ([]),
  buttonFunction = {},
  icon = <></>,
}) {
  const { isSidebarEnabled } = useIsSidebarEnabled();
  const isDashboardPath = ["/dashboard", "/"].includes(
    window.location.pathname
  );

  const bannerClassName = `base-banner ${
    isSidebarEnabled ? "" : "banner-with-background"
  }`;

  return (
    <div className={bannerClassName}>
      <div className="banner-content">
        <div className="banner-header">
          {goBack && (
            <div className="banner-chevron">
              <ChevronLeft
                className="clickable"
                name="chevron-left"
                onClick={goBack}
                style={{ margin: "auto" }}
              />
            </div>
          )}
          <h1 className="banner-title" data-testid="banner-title">
            {bannerName}
          </h1>
          <div className="banner-icon">{icon}</div>
        </div>
        {!isDashboardPath ? (
          <Feature
            features={features}
            or={orFeatureFlagChecks}
          >
            <div className="banner-button hide-at-m">
              {buttonName && (
                <Button
                  label={buttonName}
                  onClick={buttonFunction}
                  kind="plain"
                />
              )}
            </div>
            <div className="banner-button display-at-m">
              {buttonName && (
                <Button label={buttonName} onClick={buttonFunction} />
              )}
            </div>
          </Feature>
        ) : null}
      </div>
    </div>
  );
}
BaseBanner.propTypes = {
  bannerName: PropTypes.string.isRequired,
  goBack: PropTypes.func,
  buttonFunction: PropTypes.any,
  buttonName: PropTypes.string,
  features: PropTypes.object,
  orFeatureFlagChecks: PropTypes.array,
  icon: PropTypes.node,
};

